var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookMobileReelLocation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 8,
  height: 11,
  fill: "none",
  viewBox: "0 0 8 11",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M4 11c.5 0 4-3.5 4-7a4 4 0 1 0-8 0c0 3.5 3.5 7 4 7m0-5a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
  clipRule: "evenodd"
})));
export default SvgFacebookMobileReelLocation;